/** istanbul ignore file */
import { canUseDOM } from '@surfline/web-common';

export default canUseDOM;
